import { TTBIL_COMPANY_IDS } from "./common"
export function isValueThere(data) {
	const C1 = data !== undefined && data !== null && data !== ''

	if (C1) {
		return true
	}

	return false
}

export function isValueThereThenReturnData(data) {
	const C1 = data !== undefined && data !== null && data !== ''

	if (C1) {
		return data
	}

	return null
}

export const attachGoogleKeyScript = (GOOGLE_API_KEY) => {
	const script = document.createElement("script");
	script.src = 'https://maps.googleapis.com/maps/api/js?key=' + GOOGLE_API_KEY + '&v=3.exp&libraries=places';
	script.async = true;
	script.type = 'text/javascript';
	document.head.appendChild(script);
}

export const geocodeAddress = (address) => {
    return new Promise((resolve, reject) => {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': address }, function (results, status) {
            if (status === 'OK') {
                resolve(results);
            } else {
                reject('Geocode was not successful for the following reason: ' + status);
            }
        });
    });
}

export function getEmamiSeekerCompanyId() {
	let seekerCompanyId = "810e630cbfce43c79b2693c27c35103c"
	const DEPLOYED_ENV = process.env.DEPLOYED_ENV
	if(DEPLOYED_ENV === "production") {
		seekerCompanyId = "810e630cbfce43c79b2693c27c35103c"
	}else if(DEPLOYED_ENV === "QA"){
		seekerCompanyId = "66204f3fc0de46a99c7556c7c0b05699"
	}else if(DEPLOYED_ENV === "UAT"){
		seekerCompanyId = "66204f3fc0de46a99c7556c7c0b05699"
	}else if(DEPLOYED_ENV === "dev"){
		seekerCompanyId = "66204f3fc0de46a99c7556c7c0b05699"
	}
	return seekerCompanyId
}

export const isValidContactsArray = (contacts) => {
    // Check if contacts exists and is an array
    if (contacts && Array.isArray(contacts)) {
        // Check if any null values exist in the array
        if (contacts.some(contact => contact === null)) {
            return false; // Contains null values
        } else {
            return true; // Does not contain null values
        }
    } else {
        return false; // contacts is not an array or does not exist
    }
}

 export const getSecureRandomKey = () => {
	const array = new Uint32Array(1);
	window.crypto.getRandomValues(array);
	return array[0] / (0xFFFFFFFF + 1);
  };


  export function debounce(func, delay) {
	let timeoutId;
	return function(...args) {
	  if (timeoutId) {
		clearTimeout(timeoutId);
	  }
	  timeoutId = setTimeout(() => {
		func.apply(this, args);
	  }, delay);
	};
  }

export const isTTBIL = (companyId) => {
	return TTBIL_COMPANY_IDS.includes(companyId);
};